import './footer.scss';

/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment } from 'react';

import { FOOTER } from '../../../../constants/appConstants';

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Fragment>
        <footer className={this.props.className + " page-footer "}>
          <div className="footer-copyright">
            <div className="container">
              <span>
                &copy; 2026 <a href="https://cinchio.com/" target="_blank"> Cinchio Solutions, LLC</a>. {FOOTER.ALL_RIGHTS_RESERVED}.
              </span>
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }
}

export default Footer;
